/* hej-mail-chooser — kopieert het e-mailadres naar het klembord i.p.v. meteen mailto: te openen.
 * Toont kort "Gekopieerd" naast het geklikte element. Progressive enhancement: zonder JavaScript
 * blijft elk element een gewone mailto-link.
 *
 * Werkt voor elk element met data-hej-mail-chooser en href="mailto:...", op elke pagina die dit
 * bestand laadt (Contact-opnemen, Klachten, batterijconditie). Eén herbruikbaar badge-element,
 * daarom een globale listener op document in plaats van er één per trigger. Dit bestand raakt
 * bewust niet het al werkende, losse keuzemenu in sections/Klachten.liquid ("Wij horen graag van
 * u"-kaart, gedrag in assets/Klachten.js).
 */
(function () {
  var badge = null;
  var resetTimer = null;

  function parseEmail(href) {
    var match = /^mailto:([^?]*)/i.exec(href || "");
    return match ? decodeURIComponent(match[1] || "") : "";
  }

  function showBadge(trigger, text) {
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "hej-mc-badge";
      badge.setAttribute("role", "status");
    }
    badge.textContent = text;
    /* Als laatste kind van de eigen ouder ingevoegd (nooit naar <body> verplaatst), niet direct
       ná de trigger: iets anders dat ook naast de trigger inhaakt (bv. een browserextensie die
       mailto-links herkent) krijgt zo geen kans om ertussen te komen te zitten. position:fixed,
       dus viewport-coördinaten en geen scrollX/scrollY nodig. Positie wordt na een animatieframe
       herberekend (dus ná eventuele lay-outwijzigingen door zulke extensies) en blijft altijd
       binnen het scherm. */
    (trigger.parentNode || document.body).appendChild(badge);
    badge.hidden = false;
    requestAnimationFrame(function () {
      var rect = trigger.getBoundingClientRect();
      var left = rect.left + rect.width / 2;
      var margin = 8;
      var half = badge.offsetWidth / 2;
      left = Math.min(Math.max(left, margin + half), window.innerWidth - margin - half);
      badge.style.top = (rect.bottom + 8) + "px";
      badge.style.left = left + "px";
    });
    if (resetTimer) clearTimeout(resetTimer);
    resetTimer = setTimeout(function () { badge.hidden = true; }, 1800);
  }

  function copyEmail(trigger, email) {
    function done(ok) {
      showBadge(trigger, ok ? (email + " gekopieerd") : "Kopiëren mislukt");
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(email).then(function () { done(true); }, function () { done(false); });
    } else {
      done(false);
    }
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-hej-mail-chooser]");
    if (!trigger) return;
    e.preventDefault();
    var email = parseEmail(trigger.getAttribute("href"));
    if (!email) return;
    copyEmail(trigger, email);
  });

  window.addEventListener("scroll", function () { if (badge && !badge.hidden) badge.hidden = true; }, true);
})();
